import type { FigmaIconProps } from './types';

export const IconFigmaFile = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.06641 13.3333V2.66667C2.06641 2.15391 2.27024 1.66205 2.63281 1.29948C2.99538 0.936909 3.48725 0.733073 4 0.733073H10L10.0592 0.736328C10.1966 0.749956 10.326 0.810385 10.4245 0.908854L13.7578 4.24219C13.8703 4.35471 13.9336 4.50754 13.9336 4.66667V13.3333C13.9336 13.8461 13.7298 14.338 13.3672 14.7005C13.0046 15.0631 12.5128 15.2669 12 15.2669H4C3.48725 15.2669 2.99538 15.0631 2.63281 14.7005C2.27024 14.338 2.06641 13.8461 2.06641 13.3333ZM3.26693 13.3333C3.26693 13.5278 3.34424 13.714 3.48177 13.8516C3.6193 13.9891 3.80551 14.0664 4 14.0664H12C12.1945 14.0664 12.3807 13.9891 12.5182 13.8516C12.6558 13.714 12.7331 13.5278 12.7331 13.3333V4.91536L9.7513 1.93359H4C3.80551 1.93359 3.6193 2.01091 3.48177 2.14844C3.34424 2.28596 3.26693 2.47217 3.26693 2.66667V13.3333Z"
      fill={color}
    />
    <path
      d="M8.73307 4V1.33333C8.73307 1.00196 9.00196 0.733073 9.33333 0.733073C9.6647 0.733073 9.93359 1.00196 9.93359 1.33333V4C9.93359 4.19449 10.0109 4.3807 10.1484 4.51823C10.286 4.65576 10.4722 4.73307 10.6667 4.73307H13.3333C13.6647 4.73307 13.9336 5.00196 13.9336 5.33333C13.9336 5.6647 13.6647 5.93359 13.3333 5.93359H10.6667C10.1539 5.93359 9.66205 5.72976 9.29948 5.36719C8.93691 5.00462 8.73307 4.51275 8.73307 4Z"
      fill={color}
    />
    <path
      d="M9.57552 8.24219C9.80984 8.00787 10.1902 8.00787 10.4245 8.24219C10.6588 8.4765 10.6588 8.85683 10.4245 9.09115L7.75781 11.7578C7.5235 11.9921 7.14317 11.9921 6.90885 11.7578L5.57552 10.4245C5.34121 10.1902 5.34121 9.80984 5.57552 9.57552C5.80984 9.34121 6.19016 9.34121 6.42448 9.57552L7.33333 10.4844L9.57552 8.24219Z"
      fill={color}
    />
  </svg>
);
